module.exports = __webpack_public_path__ + "img/link.58ef6562.svg";